<app-loading *ngIf="isLoading"></app-loading>
<div class="detail-container loadingInfo">
  <div class="d-flex">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 titleContent">
    <label>{{ "claimOffice.loadingInformation.title" | translate }}</label>
  </div>
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 text-right">
    <img
    class="close"
    src="{{ RESOURCE_SERVER_URL }}/assets/images/Close.svg"
    alt="Close Icon"
    (click)="onClose()"
  />  </div>
  </div>

  <dxc-table class="table-responsive-sm dashabordTable pt-4" >
    <tr class="header-filter">
      <!-- Coverage -->
      <th class="" id="coverage">
        {{ "claimOffice.loadingInformation.coverage" | translate }}
      </th>
      <!-- rider -->
      <th class="" id="rider">
        {{ "claimOffice.loadingInformation.rider" | translate }}
      </th>
      <!-- Sum Assured -->
      <th class="" id="originalSA">
        {{ "claimOffice.loadingInformation.originalSA" | translate }}
      </th>
      <!-- Premium -->
      <th class="" id="premium">
        {{ "claimOffice.loadingInformation.premium" | translate }}
      </th>
      <th class="" id="tax">
        {{ "claimOffice.loadingInformation.tax" | translate }}
      </th>
      <th class="" id="totalPremium">
        {{ "claimOffice.loadingInformation.totalPremium" | translate }}
      </th>
      <th class="" id="status">
        {{ "claimOffice.loadingInformation.status" | translate }}
      </th>
      <!-- Medical -->
      <th id="age">
        {{ "claimOffice.loadingInformation.age" | translate }}
      </th>
      <!-- Residential -->
      <th id="radjust">
        {{ "claimOffice.loadingInformation.radjust" | translate }}
      </th>
      <!-- Lifestyle -->
      <th id="pload">
        {{ "claimOffice.loadingInformation.pload" | translate }}
      </th>
      <th id="padjust">
        {{ "claimOffice.loadingInformation.padjust" | translate }}
      </th>
      <th id="fmort">
        {{ "claimOffice.loadingInformation.fmort" | translate }}
      </th>
    </tr>
    <ng-container *ngFor="let item of loadingInformation">
      <tr class="table-header">
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.coverage" | translate }}</span>
          <img *ngIf="item.coverageBenefitDesc"       
            src="{{ RESOURCE_SERVER_URL }}/assets/images/Claim_Office/List_Policies/Add_circle.svg"
            alt="Add Circle Icon"
            (click)="showExclusion(item)" />
          <span>{{' '}}{{ item.coverageBenefitDesc }}</span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.rider" | translate }}</span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.originalSA" | translate }}</span>
          <span>{{ stringToNumber(item.coverageSumInsured) | currency:currencyCode:'symbol-narrow' }}</span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.premium" | translate }}</span>
          <span>{{ stringToNumber(item.coveragePremium) | currency:currencyCode:'symbol-narrow' }}</span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.tax" | translate }}</span>
          <span>
            {{ calculateTax(item.coveragePremium, item.coverageAnnualPremiumWithTax) |currency:currencyCode:'symbol-narrow' }}
          </span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.totalPremium" | translate }}</span>
          <span>{{ stringToNumber(item.coverageAnnualPremiumWithTax) | currency:currencyCode:'symbol-narrow' }}</span>
        </td>
        <td>
          <span class="mobile-label">{{ "claimOffice.loadingInformation.status" | translate }}</span>
          <span>Loading</span>
        </td>
        <ng-container>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.age" | translate }}</span>
            <span>
              {{ stringToNumber( item.loadings && item.loadings[0].ageRating? item.loadings[0].ageRating : 0) 
                | currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.radjust" | translate }}</span>
            <span>
              {{ stringToNumber( item.loadings && item.loadings[0].rateAdjustment? item.loadings[0].rateAdjustment: 0) 
                | currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.pload" | translate }}</span>
            <span>
              {{ stringToNumber( item.loadings && item.loadings[0].loadPercent? item.loadings[0].loadPercent : 0) 
                | currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.padjust" | translate }}</span>
            <span>
              {{ stringToNumber( item.loadings && item.loadings[0].premiumAdjusted?item.loadings[0].premiumAdjusted : 0) 
                | currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.fmort" | translate }}</span>
            <span>
              {{ stringToNumber(item.loadings && item.loadings[0].flatMortality? item.loadings[0].flatMortality : 0) 
                | currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
        </ng-container>
      </tr>
      <ng-container *ngFor="let rider of item.riders">
        <tr class="table-header" *ngIf="item.riders.length != 0">
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.coverage" | translate }}</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.rider" | translate }}</span>
            <img src="{{ RESOURCE_SERVER_URL }}/assets/images/Claim_Office/List_Policies/Add_circle.svg" 
            alt="Add Circle Icon"
            (click)="showExclusion(rider)"/>
            <span>{{' '}}{{ rider.riderBenefitDesc }}</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.originalSA" | translate }}</span>
            <span>{{ stringToNumber(rider.riderSumInsured) |currency:currencyCode:'symbol-narrow' }}</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.premium" | translate }}</span>
            <span>{{ stringToNumber(rider.riderPremium) |currency:currencyCode:'symbol-narrow' }}</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.tax" | translate }}</span>
            <span>
              {{ calculateTax(rider.riderPremium, rider.riderAnnualPremiumWithTax) |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.totalPremium" | translate }}</span>
            <span>{{ stringToNumber(rider.riderAnnualPremiumWithTax) |currency:currencyCode:'symbol-narrow' }}</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.status" | translate }}</span>
            <span>Loading</span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.age" | translate }}</span>
            <span>
              {{ stringToNumber(item.loadings && item.loadings[0].ageRating ? item.loadings[0].ageRating : 0) 
                |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.radjust" | translate }}</span>
            <span>
              {{ stringToNumber(item.loadings && item.loadings[0].rateAdjustment ? item.loadings[0].rateAdjustment : 0) 
                |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.pload" | translate }}</span>
            <span>
            {{ stringToNumber(item.loadings && item.loadings[0].loadPercent? item.loadings[0].loadPercent : 0) 
              |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.padjust" | translate }}</span>
            <span>
              {{ stringToNumber(item.loadings && item.loadings[0].premiumAdjusted? item.loadings[0].premiumAdjusted : 0) 
                |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
          <td>
            <span class="mobile-label">{{ "claimOffice.loadingInformation.fmort" | translate }}</span>
            <span>
              {{ stringToNumber(item.loadings && item.loadings[0].flatMortality? item.loadings[0].flatMortality : 0) 
                |currency:currencyCode:'symbol-narrow' }}
            </span>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <tr class="table-header">
      <td>
      </td>
      <td>
        {{ "claimOffice.loadingInformation.totalPolicyPremium" | translate }}
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.originalSA" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'SA', '') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.premium" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'P', '') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.tax" | translate }}</span>
        <span>{{totalAmount(loadingInformation, '', 'TAX') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.totalPremium" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'TP', '') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.status" | translate }}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.age" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'A', 'L') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.radjust" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'RA', 'L') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.pload" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'PL', 'L') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.padjust" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'PA', 'L') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
      <td>
        <span class="mobile-label">{{ "claimOffice.loadingInformation.fmort" | translate }}</span>
        <span>{{totalAmount(loadingInformation, 'FM', 'L') | currency:currencyCode:'symbol-narrow'}}</span>
      </td>
    </tr>
  </dxc-table>

  <!-- Exclusion View -->
  <ng-container>
    <dxc-dialog class="file-dialog" *ngIf="viewExclusion" (onCloseClick)="closeExclusion()" [isCloseVisible]="true">
      <div class="dialog-details">
        <div class="dialog-header">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
              <label class="header-label">
                {{ "claimOffice.loadingInformation.exclusionComment" | translate }}
              </label>
            </div>
          </div>
          <hr>
        </div>
        <div *ngFor="let exclusions of exclusionList">
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-left">
              <label class="exclusions-label">{{ exclusions.exclusion }}</label>
            </div>
          </div>
          <div class="row content-alignment">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-left">
              <span class="exclusions-desc">
                {{exclusions.exclusionDescription}}
              </span>
            </div>
          </div>
          <hr />
        </div>
        <div class="thereIsNoData" *ngIf="exclusionList.length == 0">
          {{ "label.common.thereisnodata" | translate }}
        </div>
      </div>
    </dxc-dialog>
  </ng-container>
</div>
